<template>
  <esign-video-identification
    :token="$store.getters.esignToken"
    :end-point="endPoint"
    :end-point-video="endPointVideo"
    :operation-uuid="$store.getters.operationUuid"
    :domain-uuid="$store.getters.domainUuid"
  ></esign-video-identification>
</template>

<script>
import EsignVideoIdentification from "@/components/signature/VideoIdentification";
export default {
  name: "identification",
  components: {
    EsignVideoIdentification
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    this.EventBus.$on("successVideoIdentification", () => {
      this.$router.push({ name: "resumeVideoIdentification" });
    });
    this.EventBus.$on("errorVideoIdentification", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred getting the operation data. Please refresh the page.";
      this.isSnackBarVisible = true;
    });
  },
  data() {
    return {
      endPoint: process.env.VUE_APP_BASEURL,
      endPointVideo: process.env.VUE_APP_VIDEOURL
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>
